export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher50_dt_roi.778c8d79.png";